module.exports = __webpack_public_path__ + "img/27721a2.jpg";